export default __webpack_public_path__ + "static/media/Cloudxier graphics-each-expertise-02.be5398d7.png";